
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class FormWrapper extends Vue {
  @Prop({ type: String, default: "" }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly body!: string;
    @Prop({ type: String, default: "" }) readonly styleClass!: string;
}
